module.exports = __webpack_public_path__ + "static/img/service.16d8829.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/product/service.png
// module id = bFWi
// module chunks = 1